import { post } from "helpers/api_helper";
import { POST_RESEND_INVITE } from "helpers/url_helper";
import { Button } from "reactstrap";
import swal from "sweetalert";


const ResendInvite = ({ user_id, getData, setIsLoading }) => {

    const resend = () => {
        setIsLoading(true)
        post(POST_RESEND_INVITE, { user_id })
            .then(response => {
                if (response.status === 200) {
                    swal({
                        title: "Success",
                        text: response.message,
                        icon: "success",
                        button: "OK",
                    })
                    getData()
                } else {
                    if (typeof response?.message == "string") {
                        swal({
                            title: "Error",
                            text: response.message,
                            icon: "error",
                            button: "OK",
                        })
                    }
                }
                setIsLoading(false)
            })
            .catch(error => {
                error.response.data
                setIsLoading(false)
            })
    }

    return (
        <>
            <Button
                onClick={resend}
                className="btn btn-secondary waves-effect waves-light btn btn-secondary"
                style={{
                    width: "25px",
                    height: "25px",
                    padding: "0px",
                }}

                title="Resend Invite"
            >
                <i className="fas fa-redo" style={{ color: "#E74C3C" }} />
            </Button>
        </>
    )
}

export default ResendInvite;